import React from 'react';
import {Grid, Inputs, Typography} from 'components';

import {makeStyles} from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        border: `solid 1px ${theme.palette.blue}`,
        marginBottom: theme.spacing(3)
    },
    header: {
        background: theme.palette.blue,
        display: 'flex',
        alignItems: 'center',
        minHeight: 45,
        padding: theme.spacing(0, 2)
    },
    content: {
        margin: 'auto',
        maxWidth: 700,
        padding: theme.spacing(2)
    }
}));

function StepAccounts() {
    const classes = useStyles();

    return (
        <>
            <div className={classes.wrapper}>
                <div className={classes.header}>
                    <Typography
                        variant="h4"
                        color="white"
                        caps
                        semibold
                        gutterBottom={false}
                    >
                        2. Compte d'origine (à transférer)
                    </Typography>
                </div>

                <div className={classes.content}>
                    <Inputs.Text
                        name="origin_contract_number"
                        label="N° du contrat à transférer *"
                    />
                    <Inputs.Text
                        name="company_name"
                        label="Entreprise *"
                        disableCleave
                    />
                    <Inputs.Text
                        name="insurer_name"
                        label="Nom de l'assureur *"
                        disableCleave
                    />
                    <Inputs.Text
                        name="insurer_street_line"
                        label="Adresse de l'assureur *"
                        disableCleave
                    />
                    <Grid
                        container
                        spacing={1}
                    >
                        <Grid
                            item
                            sm={4}
                            xs={12}
                        >
                            <Inputs.Text
                                name="insurer_zip_postal_code"
                                label="Code postal *"
                                options={{
                                    blocks: [2, 3]
                                }}
                            />
                        </Grid>
                        <Grid
                            item
                            sm={8}
                            xs={12}
                        >
                            <Inputs.Text
                                name="insurer_locality"
                                label="Ville *"
                                disableCleave
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={2}
                    >
                        <Grid
                            item
                            sm={3}
                            xs={12}
                        >
                            <Inputs.Number
                                name="insurer_mobile"
                                label="N° de téléphone *"
                                format="phone"
                            />
                        </Grid>
                        <Grid
                            item
                            sm={9}
                            xs={12}
                        >
                            <Inputs.Text
                                name="insurer_email"
                                label="E-mail *"
                            />
                        </Grid>
                    </Grid>
                    <Typography color="blue">
                        J'ai bien noté que la totalité de mon épargne détenue sur ce contrat sera transférée.
                    </Typography>
                    <Typography color="blue">
                        ■&nbsp;&nbsp;Dans le cas d’un PERCO ou PER Collectif (PERECO), j’atteste ne pas avoir effectué
                        un transfert de mon épargne salariale durant les 3 dernières années ou avoir quitté
                        l’entreprise.
                    </Typography>
                    <Typography color="blue">
                        ■&nbsp;&nbsp;Dans le cas d’un Article 83 ou d’un PER Obligatoire, j’atteste avoir quitté
                        l’entreprise.
                    </Typography>
                    <Typography color="blue">
                        ■&nbsp;&nbsp;Je certifie être toujours en activité à ce jour et ne pas avoir liquidé mes droits
                        à la retraite du régime général.
                    </Typography>
                </div>
            </div>

            <div className={classes.wrapper}>
                <div className={classes.header}>
                    <Typography
                        variant="h4"
                        color="white"
                        caps
                        semibold
                        gutterBottom={false}
                    >
                        3. Référence du compte axa destinataire du transfert
                    </Typography>
                </div>

                <div className={classes.content}>
                    <Inputs.Text
                        name="receiver_contract_number"
                        label="N° de contrat actuel géré par AXA France Vie"
                    />
                    <Inputs.Text
                        name="receiver_company"
                        label="Entreprise"
                        disableCleave
                    />
                </div>
            </div>
            <Typography color="blue">(*) Mentions obligatoires</Typography>
        </>
    );
}

export default StepAccounts;
